import React, { useState, useEffect } from "react";
import Modal from "@cloudscape-design/components/modal";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Spinner from "@cloudscape-design/components/spinner";
import Toggle from "@cloudscape-design/components/toggle";
import Tabs from "@cloudscape-design/components/tabs";
import Table from "@cloudscape-design/components/table";
import Textarea from "@cloudscape-design/components/textarea";
import FormField from "@cloudscape-design/components/form-field";
import Select from "@cloudscape-design/components/select";
import Container from "@cloudscape-design/components/container";
import ExpandableSection from "@cloudscape-design/components/expandable-section";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { configStore } from "../stores/config";
import { groupStore } from "../stores/group";
import { groupEditModalStore } from "../stores/groupEditModal";
import { getRecoil, setRecoil } from "recoil-nexus";
import Multiselect from "@cloudscape-design/components/multiselect";
import { userStore } from "../stores/access";






class GroupEditModal extends React.Component {
	state = {
		loading: true,
		conditions: [],
		users: [],
		user: this.props.user,
		groupedUsers: [],
		name: this.props.groupEditModal.name || "",
		description: this.props.groupEditModal.description || "",
		permissions: this.props.groupEditModal.permissions
			? JSON.stringify(JSON.parse(this.props.groupEditModal.permissions), null, 2)
			: "",
		showColumn: this.props.groupEditModal.showColumn
			? JSON.stringify(JSON.parse(this.props.groupEditModal.showColumn), null, 2)
			: "",
		removeAllProjects: false,
		newUser: {
			login: null,
			brand: [],
		},
		expandedLogins: {},
		addUserLoading: false,
		addConditionalLoading: false,
		saveGroupLoading: false,
		activeTab: "details",
		newCondition: {
			columnName: "",
			conditionType: { value: "ABOVE", label: "Above" },
			conditionValue: "",
			permissionName: "",
			description: "",
			database: "",
		},
		errors: {},
	};

	componentDidMount() {
		this.fetchData();
	}

	fetchGroupConditions = async (groupId) => {
		try {
			return await this.props.Interface.request("get", { class: "panel", module: "group", method: "groupConditional" }, { id: groupId });
		} catch (e) {
			console.log(e);
			return [];
		}
	};

	fetchUserGroup = async (groupId) => {
		try {
			return await this.props.Interface.request("get", { class: "panel", module: "group", method: "userGroup" }, { id: groupId });
		} catch (e) {
			console.log(e);
			return [];
		}
	};

	fetchData = async (activeTab = "details") => {
		this.setState({ loading: true, activeTab });
		try {
			const groupId = this.props.groupEditModal.id;
			if (!Number.isInteger(groupId) || groupId < 1) {
				throw new Error("Invalid group ID");
			}
			const [conditions, users] = await Promise.all([
				this.fetchGroupConditions(groupId),
				this.fetchUserGroup(groupId),
			]);
			const groupedUsers = Object.values(
				users.reduce((acc, user) => {
					const login = user.login || "Unknown";
					if (!acc[login]) {
						acc[login] = { login, children: [] };
					}
					acc[login].children.push(user);
					return acc;
				}, {})
			);
			this.setState({ conditions, users, groupedUsers, loading: false });
		} catch (error) {
			console.error("Error fetching data:", error.message);
			this.setState({ loading: false, errors: { fetch: `Failed to load data: ${error.message}` } });
		}
	};

	validateJSON = (value) => {
		try {
			if (!value.trim()) return false;
			JSON.parse(value);
			return true;
		} catch {
			return false;
		}
	};

	validateGroupFields = () => {
		const { name, description, permissions } = this.state;
		const errors = {};

		if (!name.trim()) errors.name = "Name is required";
		if (!description.trim()) errors.description = "Description is required";
		if (!permissions.trim()) {
			errors.permissions = "Permissions are required";
		} else if (!this.validateJSON(permissions)) {
			errors.permissions = "Invalid JSON format";
		}
		if (this.state.showColumn && !this.validateJSON(this.state.showColumn)) {
			errors.showColumn = "Invalid JSON format";
		}

		return errors;
	};

	validateConditionFields = () => {
		const { columnName, conditionType, conditionValue, permissionName } = this.state.newCondition;
		const errors = {};

		if (!columnName.trim()) errors.columnName = "Column Name is required";
		if (!conditionType?.value) errors.conditionType = "Condition Type is required";
		if (!conditionValue.trim()) errors.conditionValue = "Condition Value is required";
		if (!permissionName.trim()) errors.permissionName = "Permission Name is required";

		return errors;
	};

	validateUserFields = () => {
		const { login, brand } = this.state.newUser;
		const errors = {};


		if (!login) errors.login = "Login is required";
		if (brand.length === 0) errors.brand = "Brand is required";

		return errors;
	};

	handleInputChange = (field, value) => {
		this.setState({ [field]: value, errors: { ...this.state.errors, [field]: null } });
	};

	handleNewConditionChange = (field, value) => {
		this.setState({
			newCondition: { ...this.state.newCondition, [field]: value },
			errors: { ...this.state.errors, newCondition: null },
		});
	};

	handleNewUserChange = (field, value) => {
		this.setState({
			newUser: { ...this.state.newUser, [field]: value },
			errors: { ...this.state.errors, newUser: null },
		});
	};

	handleAddCondition = async () => {
		const errors = this.validateConditionFields();
		if (Object.keys(errors).length > 0) {
			this.setState({ errors: { ...this.state.errors, newCondition: errors } });
			return;
		}

		try {
			this.setState({
				addConditionalLoading: true,
			});

			const condition = await this.props.Interface.request("set", { class: "panel", module: "group", method: "addGroupCondition" }, {
				...this.state.newCondition,
				conditionType: this.state.newCondition.conditionType.value,
				groupId: this.props.groupEditModal.id,
			});

			this.setState({
				addConditionalLoading: false,
				conditions: [...this.state.conditions, { ...this.state.newCondition,
					id: condition.insertId, 				conditionType: this.state.newCondition.conditionType.value,
					groupId: this.props.groupEditModal.id, }],
				newCondition: {
					columnName: "",
					conditionType: { value: "ABOVE", label: "Above" },
					conditionValue: "",
					permissionName: "",
					description: "",
					database: "",
				},
				errors: { ...this.state.errors, newCondition: null },
			});
		} catch (error) {
			this.setState({ errors: { newCondition: "Failed to add condition" } });
		}
	};

	handleAddUser = async () => {
		const errors = this.validateUserFields();
		if (Object.keys(errors).length > 0) {
			this.setState({ errors: { ...this.state.errors, newUser: errors } });
			return;
		}

		const brand = this.state.newUser.brand.map((e) => e.value);
		this.setState({
			addUserLoading: true,
		});

		try {
			await this.props.Interface.request("set", { class: "panel", module: "group", method: "addUserToGroup" }, {
				...this.state.newUser,
				brand,
				groupId: this.props.groupEditModal.id,
			});

			this.setState({
				newUser: {
					login: null,
					brand: [],
				},
				addUserLoading: false,
			});

			await this.fetchData("users");
		} catch (error) {
			this.setState({ errors: { newUser: "Failed to add user" } });
		}
	};

	handleDeleteCondition = async (conditionId) => {
		try {
			this.setState({
				loading: true,
				activeTab: "conditions"
			})
			await this.props.Interface.request("set", { class: "panel", module: "group", method: "deleteGroupCondition" }, {
				conditionId,
			});
			this.setState({
				loading: false,
				conditions: this.state.conditions.filter((c) => c.id !== conditionId),
			});
		} catch (error) {
			this.setState({ errors: { conditions: "Failed to delete condition" } });
		}
	};

	handleDeleteUser = async (userId) => {
		try {
			this.setState({ loading: true, activeTab: "users" });
			await this.props.Interface.request("set", { class: "panel", module: "group", method: "deleteUserToGroup" }, {
				groupId: this.props.groupEditModal.id,
				userGroupId: [userId],
			});
			const newUsers = this.state.users.filter((u) => u.id !== userId);
			const login = this.state.users.find((u) => u.id === userId)?.login;
			const newExpandedLogins = { ...this.state.expandedLogins };
			if (login && newUsers.some((u) => u.login === login)) {
				newExpandedLogins[login] = true;
			} else {
				delete newExpandedLogins[login];
			}
			this.setState({
				loading: false,
				users: newUsers,
				groupedUsers: Object.values(
					newUsers.reduce((acc, user) => {
						const login = user.login || "Unknown";
						if (!acc[login]) {
							acc[login] = { login, children: [] };
						}
						acc[login].children.push(user);
						return acc;
					}, {})
				),
				expandedLogins: newExpandedLogins,
			});
		} catch (error) {
			this.setState({ errors: { users: "Failed to remove user" } });
		}
	};


	toggleExpandableSection = (login) => {
		this.setState((prevState) => ({
			expandedLogins: {
				...prevState.expandedLogins,
				[login]: !prevState.expandedLogins[login],
			},
		}));
	};

	handleDeleteUsersByLogin = async (login) => {
		try {
			const userGroupId = this.state.users.filter((u) => u.login === login).map((u) => u.id);
			this.setState({ loading: true, activeTab: "users" });
			await this.props.Interface.request("set", { class: "panel", module: "group", method: "deleteUserToGroup" }, {
				groupId: this.props.groupEditModal.id,
				userGroupId,
			});

			const newUsers = this.state.users.filter((u) => u.login !== login);
			const newExpandedLogins = { ...this.state.expandedLogins };
			delete newExpandedLogins[login];
			this.setState({
				users: newUsers,
				loading: false,
				groupedUsers: this.state.groupedUsers.filter((g) => g.login !== login),
				expandedLogins: newExpandedLogins,
			});
		} catch (error) {
			this.setState({ errors: { users: `Failed to remove users with login ${login}` } });
		}
	};

	editGroup = async () => {
		const errors = this.validateGroupFields();
		if (Object.keys(errors).length > 0) {
			this.setState({ errors });
			return;
		}

		this.setState({ saveGroupLoading: true })
		try {
			await this.props.Interface.request("set", { class: "panel", module: "group", method: "edit" }, {
				id: this.props.groupEditModal.id, name: this.state.name,
				description: this.state.description,
				permissions: this.state.permissions ? JSON.parse(this.state.permissions) : undefined,
				showColumn: this.state.showColumn ? JSON.parse(this.state.showColumn) : undefined,
			});
			this.props.Interface.loadGroup();
			this.props.setGroupEditModal({ show: false });
		} catch (error) {
			this.setState({ errors: { form: "Failed to update group" } });
		}
	};

	render() {
		const { groupEditModal, setGroupEditModal } = this.props;
		const { loading, saveGroupLoading, expandedLogins, user,  addUserLoading, addConditionalLoading, groupedUsers, conditions, users, name, description, permissions, showColumn, removeAllProjects, newCondition, newUser, errors } = this.state;
		const brandList = user.brandsList.map((e) => ({label: e.name, value: e.id}));


		return (
			<Modal
				visible={groupEditModal.show}
				onDismiss={() => setGroupEditModal({ ...groupEditModal, show: false })}
				header={`Edit Group (${groupEditModal.id})`}
				size="max"
				footer={
					<Box float="right">
						<SpaceBetween direction="horizontal" size="xs">
							<Button
								variant="normal"
								onClick={() => setGroupEditModal({ ...groupEditModal, show: false })}
							>
								Close
							</Button>
						</SpaceBetween>
					</Box>
				}
			>
				{loading ? (
					<Box textAlign="center">
						<Spinner size="large" />
					</Box>
				) : (
					<Tabs
						activeTabId={this.state.activeTab}
						onChange={(tab) => {
							this.setState({
								activeTab: tab.detail.activeTabId,
							});
						}}
						tabs={[
							{
								label: "Group Details",
								id: "details",
								content: (
									<Container>
										<SpaceBetween direction="vertical" size="m">
											<FormField label="Name" errorText={errors.name} stretch>
												<Input
													value={name}
													onChange={({ detail }) => this.handleInputChange("name", detail.value)}
												/>
											</FormField>
											<FormField label="Description" errorText={errors.description} stretch>
												<Input
													value={description}
													onChange={({ detail }) => this.handleInputChange("description", detail.value)}
												/>
											</FormField>
											<FormField label="Permissions (JSON)" errorText={errors.permissions} stretch>
												<Textarea
													value={permissions}
													onChange={({ detail }) => this.handleInputChange("permissions", detail.value)}
													rows={6}
												/>
											</FormField>
											<FormField label="Show Column (JSON, optional)" errorText={errors.showColumn} stretch>
												<Textarea
													value={showColumn}
													onChange={({ detail }) => this.handleInputChange("showColumn", detail.value)}
													rows={6}
												/>
											</FormField>

											<Button disabled={saveGroupLoading} variant="primary" onClick={this.editGroup}>
												Save group
											</Button>
										</SpaceBetween>
									</Container>
								),
							},
							{
								label: "Conditions",
								id: "conditions",
								content: (
									<SpaceBetween direction="vertical" size="m">
										<Table
											columnDefinitions={[
												{ id: "columnName", header: "Column Name", cell: (item) => item.columnName, width: 150 },
												{ id: "conditionType", header: "Condition Type", cell: (item) => item.conditionType, width: 120 },
												{ id: "conditionValue", header: "Value", cell: (item) => item.conditionValue, width: 120 },
												{ id: "permissionName", header: "Permission", cell: (item) => item.permissionName, width: 150 },
												{ id: "description", header: "Description", cell: (item) => item.description || "-", width: 200 },
												{ id: "database", header: "Database", cell: (item) => item.database || "-", width: 150 },
												{
													id: "actions",
													header: "Actions",
													cell: (item) => (
														<Button
															variant="inline-link"
															onClick={() => this.handleDeleteCondition(item.id)}
														>
															Delete
														</Button>
													),
													width: 100,
												},
											]}
											items={conditions}
											empty={<Box textAlign="center">No conditions found</Box>}
											wrapLines
										/>
										<Container header={<Box variant="h2">Add Condition</Box>}>
											<SpaceBetween direction="vertical" size="s">
												<FormField label="Column Name" errorText={errors.newCondition?.columnName} stretch>
													<Input
														placeholder="Column name"
														value={newCondition.columnName}
														onChange={({ detail }) => this.handleNewConditionChange("columnName", detail.value)}
													/>
												</FormField>
												<FormField label="Condition Type" errorText={errors.newCondition?.conditionType} stretch>
													<Select
														selectedOption={newCondition.conditionType}
														onChange={({ detail }) => this.handleNewConditionChange("conditionType", detail.selectedOption)}
														options={[
															{ value: "ABOVE", label: "Above" },
															{ value: "BELOW", label: "Below" },
															{ value: "CONTAINS", label: "Contains" },
															{ value: "EQUALS", label: "Equals" },
															{ value: "EXCLUDE", label: "Exclude" },
															{ value: "SLICE", label: "Slice" },
														]}
													/>
												</FormField>
												<FormField label="Condition Value" errorText={errors.newCondition?.conditionValue} stretch>
													<Input
														placeholder="Condition Value"
														value={newCondition.conditionValue}
														onChange={({ detail }) => this.handleNewConditionChange("conditionValue", detail.value)}
													/>
												</FormField>
												<FormField label="Permission Name" errorText={errors.newCondition?.permissionName} stretch>
													<Input
														placeholder="Permission Name"
														value={newCondition.permissionName}
														onChange={({ detail }) => this.handleNewConditionChange("permissionName", detail.value)}
													/>
												</FormField>
												<FormField label="Description (optional)" stretch>
													<Input
														placeholder="Description (optional)"
														value={newCondition.description}
														onChange={({ detail }) => this.handleNewConditionChange("description", detail.value)}
													/>
												</FormField>
												<FormField label="Database (optional)" stretch>
													<Input
														placeholder="Database (optional)"
														value={newCondition.database}
														onChange={({ detail }) => this.handleNewConditionChange("database", detail.value)}
													/>
												</FormField>
												<Button disabled={addConditionalLoading} variant="primary" onClick={this.handleAddCondition}>
													Add Condition
												</Button>
												{errors.newCondition && typeof errors.newCondition === "string" && (
													<Box color="text-status-error">{errors.newCondition}</Box>
												)}
											</SpaceBetween>
										</Container>
									</SpaceBetween>
								),
							},
							{
								label: "Users",
								id: "users",
								content: (
									<SpaceBetween direction="vertical" size="m">
										<Container header={<Box variant="h2">Users</Box>}>
											<Table
												columnDefinitions={[
													{
														id: "login",
														header: "Login",
														cell: (item) => (
															<Box display="flex" width="100%" padding={{ vertical: "xs" }} backgroundColor="background-container">
																<SpaceBetween direction="horizontal" size="m" alignItems="center">
																	<Box variant="strong">{item.login || "-"}</Box>
																</SpaceBetween>
															</Box>
														),
														width: 200,
													},
													{
														id: "expand",
														header: "",
														cell: (item) => (
															<ExpandableSection
																headerText=""
																expanded={!!expandedLogins[item.login]}
																onChange={() => this.toggleExpandableSection(item.login)}
															>
																<Table
																	columnDefinitions={[
																		{ id: "id", header: "ID", cell: (child) => child.id, width: 100 },
																		{ id: "brand", header: "Brand", cell: (child) => child.brand || "-", minWidth: 150 },
																		{
																			id: "actions",
																			header: "Actions",
																			cell: (child) => (
																				<Button
																					variant="icon"
																					iconName="delete-marker"
																					onClick={() => this.handleDeleteUser(child.id)}
																				>
																					Delete
																				</Button>
																			),
																			width: 100,
																		},
																	]}
																	items={item.children}
																	empty={<Box textAlign="center">No users in this group</Box>}
																	wrapLines
																/>
															</ExpandableSection>
														),
													},
													{
														id: "actions",
														header: "Actions",
														cell: (item) => (
															<Box display="flex" width="100%" padding={{ vertical: "xs" }} backgroundColor="background-container">
																<SpaceBetween direction="horizontal" size="m" alignItems="center">
																	<Box float="right">
																		<Button
																			variant="icon"
																			iconName="delete-marker"
																			onClick={() => this.handleDeleteUsersByLogin(item.login)}
																		>
																			Delete
																		</Button>
																	</Box>
																</SpaceBetween>
															</Box>
														),
														width: 100,
													},
												]}
												items={groupedUsers}
												empty={<Box textAlign="center">No users found</Box>}
												wrapLines
											/>
											{errors.users && <Box color="text-status-error">{errors.users}</Box>}
										</Container>
										<Container header={<Box variant="h2">Add User</Box>}>
											<SpaceBetween direction="vertical" size="s">
												<FormField label="Login" errorText={errors.newUser?.login} stretch>
													<Input
														value={newUser.login}
														placeholder="User panel login"
														onChange={({ detail }) => this.handleNewUserChange("login", detail.value)}
													/>
												</FormField>
												<FormField label="Brand" errorText={errors.newUser?.brand} stretch>
													<Multiselect
														selectedOptions={newUser.brand}
														disabled={user.brandsList.length === 0}
														onChange={({ detail }) =>
															this.handleNewUserChange("brand", detail.selectedOptions)
														}
														options={brandList}
														placeholder="Choose brand"
													/>
												</FormField>
												<Button disabled={addUserLoading} variant="primary" onClick={this.handleAddUser}>
													Add User
												</Button>
												{errors.newUser && typeof errors.newUser === "string" && (
													<Box color="text-status-error">{errors.newUser}</Box>
												)}
											</SpaceBetween>
										</Container>
									</SpaceBetween>
								),
							},
						]}
					/>
				)}
			</Modal>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const group = useRecoilValue(groupStore);
		const setGroup = useSetRecoilState(groupStore);
		const groupEditModal = useRecoilValue(groupEditModalStore);
		const setGroupEditModal = useSetRecoilState(groupEditModalStore);
		const user = useRecoilValue(userStore);

		return (
			<Component
				{...props}
				user={user}
				group={group}
				setGroup={setGroup}
				groupEditModal={groupEditModal}
				setGroupEditModal={setGroupEditModal}
			/>
		);
	};
}

export default withRecoil(GroupEditModal);